import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class ActionLocksApp extends React.Component<ActionLocksProps, any> {
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string> = null;


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = (closeAfterSave) => {
        if (this.common.validate()) {
            HTTPService.post<JsonResultClass>("ActionLocks/SaveActionLocks", this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        this.props.entity.Id = result.Data.Id;
                        if (this.props.entity.IsNew /*&& !this.common.isWindow*/) {
                            //history.pushState(null, null, Config.baseUrl + "EmailSender/EditDataSource?id=" + encodeURIComponent(this.props.entity.Id));
                            General.Functions.HistoryState.replaceState("ActionLocks/SaveActionLocks?id=" + encodeURIComponent(this.props.entity.Id));
                        }
                        this.props.entity.IsNew = false;
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                });
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface ActionLocksProps extends AppBaseProps {
    entity: ActionLocksEntity;
    context: ActionLocksPropsContext;
}

interface ActionLocksPropsContext extends Context {
}

export interface ActionLocksEntity extends Entity {
    Id: number;
}